"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4164],{

/***/ 14164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26793);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59251);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57833);
/* harmony import */ var static_pages_foodProgram_Utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54397);
/* harmony import */ var system_components_Container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10758);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  gap: ",
        "px;\n\n  flex-direction: column;\n  align-items: center;\n\n  ",
        " {\n    flex-direction: row;\n    gap: ",
        "px;\n    align-items: flex-start;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 300px;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var ADVANTAGES = [
    {
        highlightKey: "numericHighlights.empoyer.highlight",
        descriptionKey: "numericHighlights.empoyer.description"
    },
    {
        highlightKey: "numericHighlights.fastGrowth.highlight",
        descriptionKey: "numericHighlights.fastGrowth.description"
    },
    {
        highlightKey: "numericHighlights.office.highlight",
        descriptionKey: "numericHighlights.office.description"
    }, 
];
var NumericHighlights = function(props) {
    var theme = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__.useTheme)();
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)("food_program").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        as: "section"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
            py: 6,
            textAlign: "center",
            bgcolor: theme.palette.grey[100],
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(system_components_Container__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    size: "sm",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(static_pages_foodProgram_Utils__WEBPACK_IMPORTED_MODULE_4__/* .FoodProgramH2 */ .s, {
                        mb: 6,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_i18next__WEBPACK_IMPORTED_MODULE_10__/* .Trans */ .c, {
                            t: t,
                            i18nKey: "numericHighlights.title",
                            components: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
                                    as: "span",
                                    color: theme.palette.secondary[400]
                                }, "1"), 
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(system_components_Container__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    size: "md",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Advantages, {
                        children: ADVANTAGES.map(function(param) {
                            var highlightKey = param.highlightKey, descriptionKey = param.descriptionKey;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Advantage, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AdvantageHighlight, {
                                        children: t(highlightKey)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AdvantageDescription, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_i18next__WEBPACK_IMPORTED_MODULE_10__/* .Trans */ .c, {
                                            t: t,
                                            i18nKey: descriptionKey,
                                            components: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {}, "1")
                                            ]
                                        })
                                    })
                                ]
                            }, highlightKey);
                        })
                    })
                })
            ]
        })
    }));
};
var Advantages = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(9);
});
var Advantage = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].div(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(3);
});
var AdvantageHighlight = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Typography, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        lineHeight: {
            xs: 1.5,
            sm: 1
        },
        fontSize: {
            xs: 40,
            md: 70
        },
        fontWeight: 700
    }, props));
};
var AdvantageDescription = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Typography, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        fontSize: 16
    }, props));
};
/* harmony default export */ __webpack_exports__["default"] = (NumericHighlights);


/***/ })

}]);